// ─── Helpers ───────────────────────────────────────────────────────

import { HandshakeStatus } from "@/services/handshakeService";
import { ArrowRight, Check, CheckCircle2, Clock, XCircle } from "lucide-react";
import { Card } from "@/components/ui/card";
import { formatMoney } from "@/lib/currency";

export const fmtMoney = (minor: number, currency?: string) => formatMoney(minor, currency);

export const statusBadgeVariant = (
  status: string,
): "default" | "secondary" | "destructive" | "outline" => {
  switch (status) {
    case "active":
    case "closed":
    case "acknowledged":
    case "confirmed":
      return "default";
    case "pending":
    case "requested":
      return "secondary";
    case "suspended":
    case "rejected":
    case "cancelled":
      return "destructive";
    default:
      return "outline";
  }
};

export const handshakeStatusIcon = (status: HandshakeStatus) => {
  switch (status) {
    case "requested":
      return <Clock className="h-3.5 w-3.5" />;
    case "acknowledged":
      return <Check className="h-3.5 w-3.5" />;
    case "confirmed":
      return <ArrowRight className="h-3.5 w-3.5" />;
    case "closed":
      return <CheckCircle2 className="h-3.5 w-3.5" />;
    case "rejected":
    case "cancelled":
      return <XCircle className="h-3.5 w-3.5" />;
    default:
      return null;
  }
};


// ─── Shared empty state ────────────────────────────────────────────

export function EmptyState({
  icon,
  title,
  description,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
}) {
  return (
    <Card className="p-12 flex flex-col items-center text-center">
      {icon}
      <h3 className="font-medium mt-4">{title}</h3>
      <p className="text-sm text-muted-foreground mt-1 max-w-sm">
        {description}
      </p>
    </Card>
  );
}